import React from 'react';

const ContainsToSymbol = () => {
	return (
		<>
			<div className="contains-to-symbol">&#8834;</div>
		</>
	);
};

export default ContainsToSymbol;
